、<template>
<span class="EditTask">
    <el-button class="EditTaskBtn" :type="btnType" @click="handleDialogShow">
        <slot name='btnText'>{{btnText ? btnText : $t(/*编辑*/'c.edit')}}</slot>
    </el-button>
    <el-dialog class="EditTaskDialog" :title="$t(form.id ? /*编辑*/'c.edit' : /*新增*/'c.add')+$t(/*任务*/'c.task')" width="500px" @close="handleDialogClose"
        :visible.sync="dialogShow" :modal-append-to-body="false" :close-on-click-modal="false">
        <div class="dialog-container">
            <div class="form-item required">
                <div class="key">{{$t(/*任务名称*/'task.task_name')}}</div>
                <div class="value">
                    <el-input v-model="form.name" :placeholder="$t(/*请输入*/'c.input')+$t(/*任务名称*/'task.task_name')"/>
                </div>
            </div>
            <template v-if="!detail.id">
                <div class="form-item required">
                    <div class="key">{{$t(/*设备类型*/'device.device_space')}}</div>
                    <div class="value">
                        <el-select v-model="form.space" :placeholder="$t(/*请选择*/'c.select') + $t(/*设备类型*/'device.device_space')" clearable filterable>
                            <el-option v-for="item of spaceList" :label="$t(item.key)" :value="item.value" :key="item.value"/>
                        </el-select>
                    </div>
                </div>
                <div class="form-item required" v-if="SPACE_MARK.BMS.includes(form.space)">
                    <div class="key">{{$t(/*子设备类型*/'device.target_type')}}</div>
                    <div class="value">
                        <el-select v-model="form.target_type" :placeholder="$t(/*请选择*/'c.select') + $t(/*子设备类型*/'device.target_type')" clearable filterable>
                            <el-option v-for="item of targetTypeList" :label="$t(item.key)" :value="item.value" :key="item.value"/>
                        </el-select>
                    </div>
                </div>
            </template>
            <div class="form-item required">
                <div class="key">{{$t(/*目标版本*/'task.target_version')}}</div>
                <div class="value">
                    <el-input v-model="form.target_version" :placeholder="$t(/*请输入*/'c.input') + $t(/*目标版本*/'task.target_version')"/>
                </div>
            </div>
            <div class="form-item required">
                <div class="key">{{$t(/*目标版本号*/'task.target_version_code')}}</div>
                <div class="value ">
                    <el-input v-model="form.target_version_code" type="number" :placeholder="$t(/*请输入*/'c.input') + $t(/*目标版本*/'task.target_version_code')"/>
                </div>
            </div>
            <template v-if="!detail.id">
                <div class="form-item ">
                    <div class="key">{{$t(/*计划执行时间*/'task.plan_time')}}</div>
                    <div class="value">
                        <SelectTime v-model='time'/>
                    </div>
                </div>
            </template>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleDialogClose">{{$t(/*取消*/'c.cancel')}}</el-button>
            <el-button @click="handleDialogConfirm" type="primary">{{$t(/*确定*/'c.confirm')}}</el-button>
        </div>
    </el-dialog>
</span>
</template>

<script>
import Core from '../../../core'

const SPACE_MARK = Core.Const.DEVICE.SPACE_MARK;
export default {
    name: "EditTask",
    components: {
        SelectTime: () => import('@/components/common/SelectTime.vue'),
    },
    props: {
        btnType: { type: String, default: 'text', },
        btnText: { type: String },

        detail: { type: Object, default: () => {return {}} }
    },
    data() {
        return {
            loading: false,
            dialogShow: false,

            SPACE_MARK,
			spaceList: Object.values(Core.Const.DEVICE.SPACE_MAP),
			targetTypeList: Object.values(Core.Const.OTA_TASK.TARGET_TYPE_MAP),
            form: {
                id: '',
                space: '',
				name: '',
				target_version: '',
                target_type: '',
                target_version_code: ''
            },
            time: {
                begin_time: '',
				end_time: '',
            }
        }
    },
    methods: {
        handleDialogShow() {
            if (this.detail.id) {
                for (const key in this.form) {
                    this.form[key] = this.detail[key] || ''
                }
                for (const key in this.time) {
                    this.time[key] = this.detail[key] || ''
                }
            }
            this.dialogShow = true
        },
        handleDialogClose() {
            this.dialogShow = false
            for (const key in this.form) {
                this.form[key] = ''
            }
            for (const key in this.time) {
                this.time[key] = ''
            }
        },
        handleDialogConfirm() {
            const f = Core.Util.deepCopy(this.form)
            const t = Core.Util.deepCopy(this.time)
            console.log('handleDialogConfirm',' f:', f, ' t:', t)
            if (!f.name) {
                return this.$message.warning(this.$t(/*请输入*/'c.input') + this.$t(/*任务名称*/'task.task_name'));
            }
            if (!f.space) {
                return this.$message.warning(this.$t(/*请选择*/'c.select') + this.$t(/*设备类型*/'device.device_space'));
            }
            if (SPACE_MARK.BMS.includes(this.form.space)) {
                if (!f.target_type && f.target_type !== 0) {
                    return this.$message.warning(this.$t(/*请选择*/'c.select') + this.$t(/*子设备类型*/'device.target_type'));
                }
            }
            if (!f.target_version) {
                return this.$message.warning(this.$t(/*请输入*/'c.input') + this.$t(/*目标版本*/'task.target_version'));
            }
            f.target_version_code = parseFloat(f.target_version_code)
            if (!f.target_version_code) {
                return this.$message.warning(this.$t(/*请输入*/'c.input') + this.$t(/*目标版本号*/'task.target_version_code'));
            }
            if(typeof f.target_version_code !== 'number'){
                return this.$message.warning('shuzi');
            }
            this.loading = true
            Core.Api.OtaTask.create({...f, ...t}).then(() => {
                this.$message.success(this.$t(/*操作成功*/'c.oper_success'));
                this.$emit('change')
                this.handleDialogClose();
            }).catch(err => {
                console.log('handleDialogConfirm err:', err)
                this.loading = false
            })
        },
    }

}
</script>

<style scoped lang="scss">
// .EditTask {}

</style>
